import { trackPosthog } from "../../helper/tracking/tracking";

export class PhStepTracker {

    private tracked: string[] = [];

    public constructor(
        private name: string,
        private initialStep = "login"
    ) {

    }

    public track(step: string) {

        if (this.tracked.indexOf(step) !== -1) {
            return;
        } else {

            if (step !== this.initialStep) {
                this.track(this.initialStep);
            }

            this.tracked.push(step);
            trackPosthog(this.name + " " + step);
        }


    }

    public reset() {
        this.tracked = [];
    }

}
